export const STATUS_FILTER = [
  { id: "all", value: "all", label: "All" },
  { id: "active", value: "active", label: "Active" },
  { id: "inactive", value: "inactive", label: "Inactive" },
];

export const TIMELOG_STATUS_FILTER = [
  {
    id: "pending",
    value: "PENDING",
    label: "Pending",
    dotColour: "tw-bg-yellow-500",
  },
  {
    id: "submitted",
    value: "SUBMITTED",
    label: "Submitted",
    dotColour: "tw-bg-[#25ccdb]",
  },
  {
    id: "rejected",
    value: "REJECTED",
    label: "Rejected",
    dotColour: "tw-bg-red-500",
  },
  {
    id: "submittedToManager",
    value: "SUBMITTED TO MANAGER",
    label: "Submitted to Manager",
    dotColour: "tw-bg-[#0255b0]",
  },
  {
    id: "rejectedByManager",
    value: "REJECTED BY MANAGER",
    label: "Rejected by Manager",
    dotColour: "tw-bg-red-500",
  },
  {
    id: "approvedByManager",
    value: "APPROVED BY MANAGER",
    label: "Approved By Manager",
    // dotColour: "tw-bg-[#9e1c7f]",
    dotColour: "bg-success",
  },
  {
    id: "approved",
    value: "APPROVED",
    label: "Approved",
    dotColour: "bg-success",
  },
];

export const LEAVES_STATUS_FILTER = [
  // {
  //   id: "pending",
  //   value: "PENDING",
  //   label: "Pending",
  //   dotColour: "tw-bg-yellow-500",
  // },
  {
    id: "submitted",
    value: "SUBMITTED",
    label: "Submitted",
    dotColour: "tw-bg-[#007AFF]",
  },
  {
    id: "approved",
    value: "APPROVED",
    label: "Approved",
    dotColour: "tw-bg-[#34C759]",
  },
  {
    id: "rejected",
    value: "REJECTED",
    label: "Rejected",
    dotColour: "tw-bg-red-500",
  },
  {
    id: "cancelled",
    value: "CANCELLED",
    label: "Cancelled",
    dotColour: "tw-bg-[#999999]",
  },
  {
    id: "revoked",
    value: "REVOKED",
    label: "Revoked",
    dotColour: "tw-bg-[#FF9500]",
  },
];

export const TIMELOG_STATUSES = {
  PENDING: "PENDING",
  SUBMITTED: "SUBMITTED",
  SUBMITTED_TO_MANAGER: "SUBMITTED TO MANAGER",
  APPROVED_BY_MANAGER: "APPROVED BY MANAGER",
  REJECTED_BY_MANAGER: "REJECTED BY MANAGER",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const SORT_FILTER = {
  ASC: "asc",
  DESC: "desc",
};

export const TOTAL_AVAILABLE_LEAVES = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24,
];

export const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const INVOICE_ROLES = {
  SUPER_ADMIN: "Super Admin",
  MANAGER: "Manager",
  SENIOR_MANAGER: "Senior Manager",
  DIRECTOR: "Director",
  ACCOUNTANT: "Accountant",
  MANAGEMENT: "Management",
  AUGMENTED_ADMIN: "Augmented Admin",
};
export const CATHERINE_O_NEILL = {
  name: "Catherine O'Neill",
  userEmail: "catherine.oneill@amelio-group.com",
};

export const STATUSES = {
  NEW: "New",
  APPROVED_BY_MANAGER: "Approved By Manager",
  REJECTED_BY_MANAGER: "Rejected By Manager",
  APPROVED_BY_SENIOR_MANAGER: "Approved By Senior Manager",
  REJECTED_BY_SENIOR_MANAGER: "Rejected By Senior Manager",
  APPROVED_BY_DIRECTOR: "Approved By Director",
  REJECTED_BY_DIRECTOR: "Rejected By Director",
  FINAL_APPROVAL_PENDING: "Final Approval Pending",
  ENTERED: "Entered",
};

export const projectKeyTypes = [
  { label: "Vehicle", value: "VEHICLE" },
  { label: "Overheads", value: "OVERHEAD" },
  { label: "General", value: "GENERAL" },
];

export const projectKeyTypesObject = {
  VEHICLE: "Vehicle",
  OVERHEAD: "Overheads",
  GENERAL: "General",
};

export const LEAVE_TYPES = {
  ANNUAL_LEAVE: "Annual Leave",
  SICK_LEAVE: "Sick Leave",
  ABSCENCE_LEAVE: "Absence Leave",
  CASUAL_LEAVE: "Casual Leave",
  PAID_SICK_LEAVE: "Paid Sick Leave",
};

export const LEAVE_DAY_TYPES = {
  FULL_DAY: "Full Day",
  HALF_DAY: "Half Day",
};

export const LEAVE_HALF_DAY_TYPES = {
  AM: "AM",
  PM: "PM",
};

export const SUB_MODULES = {
  VEHICLE_ASSESSMENT: "Daily Vehicle Asset Check Sheet",
  LEAK_DETECTION: "Risk Assessment",
};

// export const ROLE_NAMES = {
//   SUPER_ADMIN : 'Super Admin',
//   MANAGER : 'Manager',
//   DIRECTOR : 'Director',
//   ACCOUNTANT : 'Accountant',
//   TIMELOG_ADMIN : 'Timelog Admin',
//   TIMELOG_EMPLOYEE : 'Timelog Employee',
//   TIMELOG_USER : 'Time Log User',
//   TIMELOG_HR : 'Time Log HR',
//   HS_ADMIN : 'H&S Admin',
//   HS_USER : 'H&S User',
//   AMELIO_ADMIN : 'Amelio Admin',
// }
